import { login, logout, getProfile, getPermissionResources } from '@/api/auth'
import { getToken, setToken, removeToken } from '@/utils/auth'

const state = {
  token: getToken(),
  userInfo: null,
  permission: null
}

const mutations = {
  SET_TOKEN(state, token) {
    state.token = token
    setToken(token)
  },
  SET_USER_INFO(state, info) {
    state.userInfo = info
  },
  SET_PERMISSION(state, p) {
    state.permission = p
  },
  REMOVE_TOKEN(state) {
    state.token = ''
    state.userInfo = null
    state.permission = null
    removeToken()
  }
}

const actions = {
  async login({ commit }, { username, password }) {
    const res = await login({ username, password })
    const token = res?.token ?? res?.data?.token
    const userInfo = res?.userInfo ?? res?.data?.userInfo ?? { username }
    if (token) commit('SET_TOKEN', token)
    commit('SET_USER_INFO', userInfo || { username })
    try {
      const perm = await getPermissionResources()
      commit('SET_PERMISSION', perm?.data ?? perm ?? null)
    } catch (_) { commit('SET_PERMISSION', null) }
  },
  demoLogin({ commit }, { username }) {
    commit('SET_TOKEN', 'demo-token-' + Date.now())
    commit('SET_USER_INFO', { username: username || 'demo' })
  },
  async logout({ commit, state }) {
    const isDemo = state.token && String(state.token).startsWith('demo-token-')
    if (!isDemo) {
      try {
        await logout()
      } catch (e) {
        // ignore when backend is down
      }
    }
    commit('REMOVE_TOKEN')
  },
  async fetchPermission({ commit, state }) {
    if (!state.token) return
    try {
      const perm = await getPermissionResources()
      commit('SET_PERMISSION', perm?.data ?? perm ?? null)
      if (!state.userInfo && perm?.data) {
        const profile = await getProfile()
        const p = profile?.data ?? profile
        if (p?.username) commit('SET_USER_INFO', { ...p, canDelete: perm?.data?.canDelete ?? p?.canDelete })
      }
    } catch (_) {}
  }
}

const getters = {
  isLoggedIn: state => !!state.token,
  userInfo: state => state.userInfo,
  permission: state => state.permission,
  canDelete: state => state.permission?.canDelete ?? state.userInfo?.canDelete ?? true,
  /** 细粒度权限：是否有某页面的某操作权限。menus 为 null 表示全部 */
  canAccess: state => (page, op = 'view') => {
    const p = state.permission
    if (!p) return false
    if (p.menus === null) return true
    if (p.permissionsConfig?.pageOps) {
      const ops = p.permissionsConfig.pageOps[page]
      if (ops && Array.isArray(ops) && ops.includes(op)) return true
    }
    if (!p.menus?.includes(page)) return false
    if (op === 'view') return true
    if (op === 'delete') return p.canDelete
    return true
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
